<footer id="footer" class="footer" itemscope itemtype="https://schema.org/WPFooter">
  <div class="footer__body">
    <vc-footer-nav-section [navigations]="(footerData$ | async)?.navigation" [home]="isHome"></vc-footer-nav-section>

    <div class="footer__essentials innerContainer">
      <vc-footer-social-section
        [socials]="(footerData$ | async)?.socials"
        [home]="isHome"
        class="footer__social"
      ></vc-footer-social-section>

      <div class="footer__apps" *ngIf="lang">
        <vc-ref resource="https://app.adjust.com/2ep0vf" [blank]="true" [anchor]="false" class="footer__apps__btn">
          <img
            class="footer__apps__btn__img"
            loading="lazy"
            src="https://assets-images.vestiairecollective.com/cdn-cgi/image/f=auto,w=140,h=70,dpr=2/assets/images/pages/applications/google/google_{{
              lang
            }}.png"
            width="140"
            i18n-alt="@@FOOTER.GET_ANDROID_APP"
            alt="Download on the Google Play Store"
          />
        </vc-ref>
        <vc-ref resource="https://app.adjust.com/xa7pe2" [blank]="true" [anchor]="false" class="footer__apps__btn">
          <ng-container *ngIf="lang === 'en'; else otherAppleImg">
            <img
              loading="lazy"
              class="footer__apps__btn__img"
              src="/assets/svg/app-apple-uk.svg"
              i18n-alt="@@FOOTER.GET_IOS_APP"
              alt="Download on the App Store"
            />
          </ng-container>
          <ng-template #otherAppleImg>
            <img
              loading="lazy"
              class="footer__apps__btn__img"
              src="/assets/svg/app-apple-{{ lang }}.svg"
              i18n-alt="@@FOOTER.GET_IOS_APP"
              alt="Download on the App Store"
            />
          </ng-template>
        </vc-ref>
      </div>

      <div class="footer__internationalisation">
        <div mat-raised-button vcOpenI18nPopin>
          <div type="button" class="i18n__choices js-getUserInfo_i18n js-openPopin_i18n">
            {{ i18nvalue }}
          </div>
        </div>
      </div>

      <vc-footer-legals
        class="footer__legals"
        [legals]="(footerData$ | async)?.legals"
        [home]="isHome"
        [showAccessibilityLink]="showAccessibilityLink"
      ></vc-footer-legals>
    </div>
  </div>

  <div class="footer__bottom">
    <vc-footer-disclaimer class="footer__disclaimer" *ngIf="showDisclaimer"></vc-footer-disclaimer>
    <vc-footer-copyright
      class="footer__copyright"
      [home]="isHome"
      [pagetype]="pageType"
      [domainsLinks]="(footerData$ | async)?.domainsLinks"
    ></vc-footer-copyright>
    <vc-footer-payment-mode class="footer__paymentMode"></vc-footer-payment-mode>
  </div>
</footer>
